import { ErrorInterceptor } from './error.interceptor';
import { TokenInterceptor } from './token.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';

//import {MatNativeDateModule} from '@angular/material';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TestApiCallComponent } from './test-api-call/test-api-call.component';
import { UserAuthorizationComponent } from './user-authorization/user-authorization.component';
import { FormDatepickerComponent } from './form-datepicker/form-datepicker.component';
import { SearchBookFormComponent } from './search-book-form/search-book-form.component';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import { SearchStationInputComponent } from './search-station-input/search-station-input.component';
import { UserLoginFormComponent } from './user-login-form/user-login-form.component';
import { LoginPageComponent } from './login-page/login-page.component';

import { RouterModule, Routes } from '@angular/router';
import { OfflineHeaderComponent } from './offline-header/offline-header.component';
import { TestThemeSwitcherComponent } from './test-theme-switcher/test-theme-switcher.component'
import { OverlayModule } from '@angular/cdk/overlay';
import { OfflineFooterComponent } from './offline-footer/offline-footer.component';
import { OfflineHomePageComponent } from './offline-home-page/offline-home-page.component';
import { OfflineServiceMenuComponent } from './offline-service-menu/offline-service-menu.component';
import { ServiceItemComponent } from './offline-service-menu/service-item/service-item.component';
import { ServiceSelectComponent } from './service-select/service-select.component';
//import { MobileSideBarComponent } from './mobile-side-bar/mobile-side-bar.component';
import { ServiceSelectMobileComponent } from './service-select-mobile/service-select-mobile.component';
import { LeafletMapComponent } from './leaflet-map/leaflet-map.component';
import { OfflineHeadImgComponent } from './offline-head-img/offline-head-img.component';
import { OfflineCardPresentationComponent } from './offline-card-presentation/offline-card-presentation.component';
import { Path } from 'leaflet';
import { OfflineServiceDescriptionComponent } from './offline-service-description/offline-service-description.component';
import { OfflineCommunityMapComponent } from './offline-community-map/offline-community-map.component';
import { OfflineCommunityDetailComponent } from './offline-community-detail/offline-community-detail.component';
import { OfflineCcmComponent } from './offline-ccm/offline-ccm.component';
import { SecondaryFooterComponent } from './secondary-footer/secondary-footer.component';
import { MainFooterComponent } from './main-footer/main-footer.component';
import { BasicAutopartageComponent } from './basic-autopartage/basic-autopartage.component';
import { CookieService } from 'ngx-cookie-service';
import { LoginHomePageComponent } from './login-home-page/login-home-page.component';
import { AuthHeaderComponent } from './auth/auth-header/auth-header.component';
import { ServiceMenuComponent } from './auth/service-menu/service-menu.component';
import { AutopartageComponent } from './auth/autopartage/autopartage.component';
import { StationDetailComponent } from './station-detail/station-detail.component';
import { StationListComponent } from './book/station-list/station-list.component';
import { StationBookDetailComponent } from './book/station-book-detail/station-book-detail.component';
import { BookConfirmationComponent } from './book/book-confirmation/book-confirmation.component';
import { UserDashboardComponent } from './book/user-dashboard/user-dashboard.component';
import { BookDetailComponent } from './auth/book-detail/book-detail.component';
import { LastStationComponent } from './auth/dashboard-block/last-station/last-station.component';
import { NextBookComponent } from './auth/dashboard-block/next-book/next-book.component';
import { LeafletMapStationZoomComponent } from './leaflet/leaflet-map-station-zoom/leaflet-map-station-zoom.component';
import { UserInfoComponent } from './auth/dashboard-block/user-info/user-info.component';
import { EcoBilanResumeComponent } from './auth/dashboard-block/eco-bilan-resume/eco-bilan-resume.component';
import { UserSubInfoComponent } from './auth/dashboard-block/user-sub-info/user-sub-info.component';
import { StationMainInfoComponent } from './auth/station/station-main-info/station-main-info.component';
import { BookInfoBlockComponent } from './auth/book/book-info-block/book-info-block.component';
import { StationAvailabilitiesGraphComponent } from './auth/station/station-availabilities-graph/station-availabilities-graph.component';
import { BookEditBlockComponent } from './auth/book/book-edit-block/book-edit-block.component';
import { BookExtendFormComponent } from './auth/book/book-extend-form/book-extend-form.component';
import { BookExtendConfirmDialogComponent } from './auth/book/book-extend-confirm-dialog/book-extend-confirm-dialog.component';
import { DefaultClemLoadingComponent } from './global/default-clem-loading/default-clem-loading.component';
import { BookCancelConfirmDialogComponent } from './auth/book/book-cancel-confirm-dialog/book-cancel-confirm-dialog.component';
import { BookEcoBilanComponent } from './auth/book/book-eco-bilan/book-eco-bilan.component';
import { BookListPageComponent } from './auth/book/book-list-page/book-list-page.component';
import { BookListTableBlockComponent } from './auth/book/book-list-table-block/book-list-table-block.component';
import { BookTableComponent } from './auth/book/book-table/book-table.component';
import { WalletListComponent } from './auth/sub/wallet-list/wallet-list.component';
import { HeaderComponent } from './header/header.component';
import { CcmAutopartageComponent } from './offline/ccm-autopartage/ccm-autopartage.component';
import { InfoBlocAutopartageComponent } from './offline/info-bloc-autopartage/info-bloc-autopartage.component';
import { SidenavContentComponent as SidenavContentOfflineComponent} from './offline/sidenav-content/sidenav-content.component';
import { SidenavContentComponent as SidenavContentAuthComponent } from './auth/sidenav-content/sidenav-content.component';
import { SidenavContentComponent } from './sidenav-content/sidenav-content.component';
import { LogoutComponent } from './logout/logout.component';
import { BasicPageComponent } from './recharge/basic-page/basic-page.component';
import { RechargeSearchFormComponent } from './recharge/recharge-search-form/recharge-search-form.component';
import { UserProfilComponent } from './auth/user/user-profil/user-profil.component';
import { DefaultHomeComponent } from './default-home/default-home.component';
import { BasicServiceComponent } from './service/basic-service/basic-service.component';
import { RechargeCcmComponent } from './recharge-ccm/recharge-ccm.component';
import { RechargeInfoBlockComponent } from './recharge-info-block/recharge-info-block.component';
import { PagecreatorComponent } from './pageCreator/pagecreator/pagecreator.component';
import { AutocompleteComponent } from './map/autocomplete-component/autocomplete-component.component';
import { LostPasswordComponent } from './login/lost-password/lost-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginBaseComponent } from './loginPage/login-base/login-base.component';
import { ExpansionPanelComponent } from './book/expansion-panel/expansion-panel.component';
import { UserFormulaComponent } from './user/user-formula/user-formula.component';
import { UserEcoComponent } from './user/user-eco/user-eco.component';
import { DateTableComponent } from './block/date-table/date-table.component';

import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { CookieDialogComponent } from './dialog/cookie/cookie.component';
import { UserEditProfilComponent } from './user/user-edit-profil/user-edit-profil.component';
import { UserEditPasswordComponent } from './user/user-edit-password/user-edit-password.component';
import { SidenavContentOfflineRechargeComponent } from './offline/sidenav-content-offline-recharge/sidenav-content-offline-recharge.component';
import { SidenavContentRechargeComponent } from './auth/sidenav-content-recharge/sidenav-content-recharge.component';
import { MentionLegalesComponent } from './informations-legales/mention-legales/mention-legales.component';
import { CguComponent } from './informations-legales/cgu/cgu.component';
import { PolitiqueConfidentialiteComponent } from './informations-legales/politique-confidentialite/politique-confidentialite.component';
import { ConfirmComponent } from './auth/book/book-info-block/confirm/confirm.component';
import { ExtendComponent } from './auth/book/book-info-block/extend/extend.component';
import { DialogComponent } from './auth/book/book-info-block/dialog/dialog.component';
import { FactureListComponent } from './user/user-eco/facture-list/facture-list.component';
import { DialogErrorComponent } from './search-book-form/dialog-error/dialog-error.component';
import { ErrorBookComponent } from './book/book-confirmation/error-book/error-book.component';
import { ValidateCguComponent } from './dialog/validate-cgu/validate-cgu.component';
import { CarBlocAutopartageComponent } from './offline/car-bloc-autopartage/car-bloc-autopartage.component';
import { SubscribeComponent } from './subscribe/subscribe.component';
import {NgxMatIntlTelInputModule} from 'ngx-mat-intl-tel-input';
import { FaqComponent } from './informations-legales/faq/faq.component';
import { InformerComponent } from './offline/informer/informer.component';
import { CommunauteComponent } from './offline/communaute/communaute.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RechargeSansInscriptionComponent } from './recharge-sans-inscription/recharge-sans-inscription.component';
import { PaymentRechargeSansInscriptionComponent } from './recharge-sans-inscription/payment-recharge-sans-inscription/payment-recharge-sans-inscription.component';
import { ConfirmPaymentRechargeSansInscriptionComponent } from './recharge-sans-inscription/payment-recharge-sans-inscription/confirm-payment-recharge-sans-inscription/confirm-payment-recharge-sans-inscription.component';
import { RetourRechargeSansInscriptionComponent } from './recharge-sans-inscription/retour-recharge-sans-inscription/retour-recharge-sans-inscription.component';
import { ConfirmRetourComponent } from './recharge-sans-inscription/retour-recharge-sans-inscription/confirm-retour/confirm-retour.component';
import { InstructionComponent } from './auth/book/book-info-block/instruction/instruction.component';
import { StopComponent } from './auth/book/book-info-block/stop/stop.component';
import { AutologinComponent } from './autologin/autologin.component';
import { PopupUserComponent } from './auth/user/user-profil/popup-user/popup-user.component';
import { AutorisationCameraComponent } from './auth/user/user-profil/autorisation-camera/autorisation-camera.component';
import { CovoiturageComponent } from './auth/covoiturage/covoiturage.component';
import { DetailCovoiturageComponent } from './auth/covoiturage/detail-covoiturage/detail-covoiturage.component';
import { ConsommationsComponent } from './auth/consommations/consommations.component';
import { RefreshTokenComponent } from './auth/refresh-token/refresh-token.component';



export function TranslationLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

 
const dbConfig: DBConfig  = {
  name: 'clem-bd',
  version: 1,
  objectStoresMeta: [{
    store: 'station',
    storeConfig: { keyPath: 'id', autoIncrement: false },
    storeSchema: [
      { name: 'autonomy', keypath: 'autonomy', options: { unique: false } },
      { name: 'available', keypath: 'available', options: { unique: false } },
      { name: 'car_name', keypath: 'car_name', options: { unique: false } },
      { name: 'guest_booking', keypath: 'guest_booking', options: { unique: false } },
      { name: 'id', keypath: 'id', options: { unique: false } },
      { name: 'latitude', keypath: 'latitude', options: { unique: false } },
      { name: 'longitude', keypath: 'longitude', options: { unique: false } },
      { name: 'name', keypath: 'name', options: { unique: false } },
      { name: 'type', keypath: 'type', options: { unique: false } }
    ]
  },
  {
    store: 'data_expire_time',
    storeConfig: { keyPath: 'name', autoIncrement: false },
    storeSchema: [
      { name: 'name', keypath: 'name', options: { unique: false } },
      { name: 'expire_time', keypath: 'expire_time', options: { unique: false } }
    ]
  }]
};

@NgModule({
  
  declarations: [
    AppComponent,
    TestApiCallComponent,
    UserAuthorizationComponent,
    FormDatepickerComponent,
    SearchBookFormComponent,
    SearchStationInputComponent,
    UserLoginFormComponent,
    LoginPageComponent,
    OfflineHeaderComponent,
    TestThemeSwitcherComponent,
    OfflineFooterComponent,
    OfflineHomePageComponent,
    OfflineServiceMenuComponent,
    ServiceItemComponent,
    ServiceSelectComponent,
   // MobileSideBarComponent,
    ServiceSelectMobileComponent,
    LeafletMapComponent,
    OfflineHeadImgComponent,
    OfflineCardPresentationComponent,
    OfflineServiceDescriptionComponent,
    OfflineCommunityMapComponent,
    OfflineCommunityDetailComponent,
    OfflineCcmComponent,
    SecondaryFooterComponent,
    MainFooterComponent,
    BasicAutopartageComponent,
    LoginHomePageComponent,
    AuthHeaderComponent,
    ServiceMenuComponent,
    AutopartageComponent,
    StationDetailComponent,
    StationListComponent,
    StationBookDetailComponent,
    BookConfirmationComponent,
    UserDashboardComponent,
    BookDetailComponent,
    LastStationComponent,
    NextBookComponent,
    LeafletMapStationZoomComponent,
    UserInfoComponent,
    EcoBilanResumeComponent,
    UserSubInfoComponent,
    StationMainInfoComponent,
    BookInfoBlockComponent,
    StationAvailabilitiesGraphComponent,
    BookEditBlockComponent,
    BookExtendFormComponent,
    BookExtendConfirmDialogComponent,
    DefaultClemLoadingComponent,
    BookCancelConfirmDialogComponent,
    BookEcoBilanComponent,
    BookListPageComponent,
    BookListTableBlockComponent,
    BookTableComponent,
    WalletListComponent,
    HeaderComponent,
    CcmAutopartageComponent,
    InfoBlocAutopartageComponent,
    SidenavContentOfflineComponent,
    SidenavContentAuthComponent,
    SidenavContentComponent,
    LogoutComponent,
    BasicPageComponent,
    RechargeSearchFormComponent,
    UserProfilComponent,
    DefaultHomeComponent,
    BasicServiceComponent,
    RechargeCcmComponent,
    RechargeInfoBlockComponent,
    PagecreatorComponent,
    AutocompleteComponent,
    LostPasswordComponent,
    ResetPasswordComponent,
    LoginBaseComponent,
    ExpansionPanelComponent,
    UserFormulaComponent,
    UserEcoComponent,
    DateTableComponent,
    CookieDialogComponent,
    UserEditProfilComponent,
    UserEditPasswordComponent,
    SidenavContentOfflineRechargeComponent,
    SidenavContentRechargeComponent,
    MentionLegalesComponent,
    CguComponent,
    PolitiqueConfidentialiteComponent,
    ConfirmComponent,
    ExtendComponent,
    DialogComponent,
    FactureListComponent,
    DialogErrorComponent,
    ErrorBookComponent,
    ValidateCguComponent,
    CarBlocAutopartageComponent,
    SubscribeComponent,
    FaqComponent,
    InformerComponent,
    CommunauteComponent,
    RechargeSansInscriptionComponent,
    PaymentRechargeSansInscriptionComponent,
    ConfirmPaymentRechargeSansInscriptionComponent,
    RetourRechargeSansInscriptionComponent,
    ConfirmRetourComponent,
    InstructionComponent,
    StopComponent,
    AutologinComponent,
    PopupUserComponent,
    AutorisationCameraComponent,
    CovoiturageComponent,
    DetailCovoiturageComponent,
    ConsommationsComponent,
    RefreshTokenComponent,
    // SeachBookMapBlockComponent,
    
  ],
  entryComponents: [LeafletMapStationZoomComponent,BookExtendConfirmDialogComponent, BookCancelConfirmDialogComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    MaterialModule,
    MatNativeDateModule,
    NgxMatIntlTelInputModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TextMaskModule,
    OverlayModule,
    TranslateModule.forRoot({
      loader: {provide: TranslateLoader, useFactory: TranslationLoaderFactory, deps: [HttpClient]}
}),
    NgxIndexedDBModule.forRoot(dbConfig)
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'}, 
    CookieService],
  bootstrap: [AppComponent]
})
export class AppModule {
  
}

